import request from '../utils/request';
export const login = data =>{
    return request({
        url: `/member/member/login`,
        method: 'post',
        data
    })
}
export const register = data =>{
    return request({
        url: `/member/member/insert`,
        method: 'post',
        data
    })
}
export const getInfo = () =>{
    return request({
        url: '/member/info',
        method: 'get'
    })
}
// 手动获取角色信息需要用户id
export const getUserInfo = () =>{
    return request({
        url: '/member/member/currentUser',
        method: 'get'
    })
}